import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { AgentPhaseBadge } from "@/lib/lifecycleBadge";
import type { Agent } from "@/types";

// #redesign Welle B (#4) — kompakte Agent-Liste für Cross-Linking-Sektionen
// (User→eigene Agents, Node→zugewiesene Agents). DRY: ein Tabellen-Layout, zwei Nutzer.
export function AgentMiniTable({ agents, emptyText }: { agents: Agent[]; emptyText: string }) {
  if (agents.length === 0) {
    return <p className="text-sm text-overlay0">{emptyText}</p>;
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Agent</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Phase</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {agents.map((a) => (
          <TableRow key={a.id}>
            <TableCell>
              <Link to={`/agents/${a.id}`} className="font-medium text-blue hover:underline">
                {a.name}
              </Link>
              <div className="font-mono text-xs text-subtext0">{a.id}</div>
            </TableCell>
            <TableCell>
              <Badge variant={a.type === "user-agent" ? "default" : "outline"}>
                {a.type === "user-agent" ? "user" : "service"}
              </Badge>
            </TableCell>
            <TableCell>
              {a.revokedAt ? <Badge variant="revoked">revoked</Badge> : <AgentPhaseBadge phase={a.lifecyclePhase} />}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
